"use client";

import { useEffect } from "react";
import { X } from "lucide-react";
import { cn } from "@/lib/utils";

type ImageLightboxProps = {
  src: string | null;
  alt?: string;
  onClose: () => void;
};

export default function ImageLightbox({ src, alt = "", onClose }: ImageLightboxProps) {
  // ESC để đóng
  useEffect(() => {
    if (!src) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [src, onClose]);

  // Khóa scroll khi mở
  useEffect(() => {
    if (src) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [src]);

  if (!src) return null;

  return (
    <div
      onClick={onClose}
      className={cn(
        "fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-8",
        "bg-black/85 backdrop-blur-sm animate-fade-in"
      )}
      role="dialog"
      aria-modal="true"
      aria-label="Xem ảnh phóng to"
    >
      {/* Close button — to, dễ nhấn */}
      <button
        onClick={onClose}
        aria-label="Đóng"
        className="absolute top-4 right-4 sm:top-6 sm:right-6 z-10 w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/20 flex items-center justify-center text-white hover:scale-110 transition-all shadow-card-lg"
      >
        <X className="w-6 h-6 sm:w-7 sm:h-7" strokeWidth={2.5} />
      </button>

      {/* Image — click vào ảnh không đóng (chỉ click background mới đóng) */}
      <img
        src={src}
        alt={alt}
        onClick={(e) => e.stopPropagation()}
        className="w-auto h-auto max-w-[95vw] max-h-[95vh] object-contain rounded-lg shadow-card-lg cursor-default"
      />
    </div>
  );
}
